export default function Home() {

    return (
        <main className='min-h-screen flex flex-col bg-gradient-to-br from-slate-50 to-slate-100'>
            <div className='flex-grow'>
                <section className='overflow-hidden'>
                    <div className='mx-auto max-w-6xl px-6 py-28'>
                        <div className='max-w-3xl'>
                            <h1 className='text-5xl font-extrabold tracking-tight text-slate-900'>
                                patient ready.  practice ready.  <br/> <span className='bg-gradient-to-r from-docpgrPurple to-[#27187e] bg-clip-text text-transparent'>get invoco.</span>
                            </h1>

                            <div className='mt-10 flex flex-wrap gap-4'>
                                <a href='/login' className='inline-flex items-center justify-center rounded-lg px-6 py-3 text-white font-semibold shadow-lg voco-gradient-hover transition'>
                                    sign in
                                </a>
                                <a href='mailto:sales@getinvoco.com' className='inline-flex items-center justify-center rounded-lg px-6 py-3 text-white font-semibold shadow-lg voco-gradient-hover'>
                                    contact sales
                                </a>
                            </div>
                        </div>
                    </div>
                </section>

                <section className='mx-auto max-w-6xl px-6'>
                    <div className='grid gap-6 md:grid-cols-2'>
                        <div className='rounded-xl bg-white p-8 shadow-md hover:shadow-lg transition'>
                            <h3 className='text-lg font-semibold text-slate-900'>
                                sales
                            </h3>
                            <p className='mt-2 text-slate-600'>
                                questions about getting voco in your office?
                            </p>
                            <a href='mailto:sales@getinvoco.com' className='mt-4 inline-block text-docpgrPurple font-semibold hover:underline'>
                                sales@getinvoco.com
                            </a>
                        </div>

                        <div className='rounded-xl bg-white p-8 shadow-md hover:shadow-lg transition'>
                            <h3 className='text-lg font-semibold text-slate-900'>
                                support
                            </h3>
                            <p className='mt-2 text-slate-600'>
                                need help with an existing account?
                            </p>
                            <a href='mailto:support@getinvoco.com' className='mt-4 inline-block text-docpgrPurple font-semibold hover:underline'>
                                support@getinvoco.com
                            </a>
                        </div>
                    </div>
                </section>
            </div>

            <footer className='border-t border-slate-200 bg-white'>
                <div className='mx-auto max-w-6xl px-6 py-6 flex justify-between text-sm text-slate-500'>
                    <span>© {new Date().getFullYear()} invoco solutions llc</span>
                    <a href='/privacy-policy' className='hover:text-slate-700 hover:underline'>
                        privacy policy
                    </a>
                </div>
            </footer>
        </main>
    )
}